import React from 'react';

const DefaultPage = () => {
    return (
        <div>
            <h1>Page not found</h1>
        </div>
    );
};

export default DefaultPage;
